var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-pagination',{attrs:{"id":"paginate.navigation","length":_vm.last_page,"total-visible":8,"prev-icon":"mdi-chevron-left","next-icon":"mdi-chevron-right"},model:{value:(_vm.localCurrent_page),callback:function ($$v) {_vm.localCurrent_page=$$v},expression:"localCurrent_page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }